import { handleGetRequest } from "./GetTemplate";
import { handlePostRequest } from "./PostTemplate";
import { handlePutRequest } from "./PutTemplate";

// A purchase invoice is goods the business bought for a client (Amazon etc.),
// billed separately from shipping. Until one of its linked packages carries a
// flight number the invoice has no shipmentNumber - isUnassignedPurchase is
// what the admin billing pages use to keep those in their own "Purchases" tab.
export const isPurchaseInvoice = (invoice) => invoice?.invoiceCategory === "purchase";

export const isUnassignedPurchase = (invoice) => isPurchaseInvoice(invoice) && !invoice.shipmentNumber;

export const createPurchaseInvoice = (dispatch, payload) => dispatch(handlePostRequest(payload, "/purchaseInvoice", true, true));

export const editPurchaseInvoice = (id, payload) => handlePutRequest(payload, `/purchaseInvoice/${id}`);

export const setPurchaseInvoicePackages = (id, packageIds) => handlePutRequest({ packageIds }, `/purchaseInvoice/${id}/packages`);

export const voidPurchaseInvoice = (dispatch, id, reason) => dispatch(handlePostRequest({ reason }, `/purchaseInvoice/${id}/void`, true, true));

export const fetchClientPackagesForPurchase = (clientId) => handleGetRequest(`/purchaseInvoice/client-packages/${clientId}`);
